
import { createContext } from "react";

export const ReportFormModalContext = createContext();